function resetSierra(): void {
    window.sierra?.cleanup?.();
}

export { resetSierra };
